import React, { Component } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { ReactPageLoader } from "../../../../../Common/Components/ReactPageLoader";
import { resolve, reject } from "q";
import { Utils } from "../../../../../Common/Utilis";
import { toast } from "react-toastify";
import './taxAudit.scss'
import { TaxCategoty } from "./Slideouts/TaxCategory";
import { DailyActivityService as TaxAuditService } from "../../../../../Common/Services/DailyActivity";
import _ from "lodash";

class TaxAudit extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      isDataLoading: false,
      tableData: [],
      defTableData: [],
      searchText: "",
      isDataSaving: false,
      isModified: false,
      taxCategoryModal: false,
      taxCatModal: false,
      selectedRow: {}
    };

    this.getTaxAuditTransactions = this.getTaxAuditTransactions.bind(this)
  }

  componentDidMount(): void {
    this.getTaxAuditTransactions();
  }

  componentDidUpdate(prevProps) {
    if (!this.props.isLoadingDefaultDate && (prevProps.selectedDate !== this.props.selectedDate || prevProps.filterHotelId !== this.props.filterHotelId)) {
      if (this.props.selectedDate) {
        this.setState({ tableData: [], deftableData: [] });
        this.getTaxAuditTransactions();
      } else {
        this.setState({ tableData: [], deftableData: [] });
      }
    }
  }

  getTaxAuditTransactions = async () => {
    const { filterHotelId, selectedDate } = this.props;
    this.setState({ isDataLoading: true });
    TaxAuditService.GetTaxAuditTransactions(filterHotelId, selectedDate)
      .then(async (result: any | null) => {
        if (result !== null && result.length > 0) {
          result = result.map((o: any) => {
            o.expectedTax = Utils.currencyFormatWithOutdoller(o.expectedTax);
            o.collectedTax = Utils.currencyFormatWithOutdoller(o.collectedTax);
            o.variance = Utils.currencyFormatWithOutdoller(o.variance);
            return o
          })
          this.setState({ tableData: result, defTableData: result, isDataLoading: false });
        } else {
          this.setState({ tableData: [], defTableData: [], isDataLoading: false });
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ tableData: [], isDataLoading: false });
        Utils.toastError(error?.message, { position: toast.POSITION.BOTTOM_RIGHT });
        reject();
      });
  };

  handleSearch = (event) => {
    let filterData = Object.assign([], JSON.parse(JSON.stringify(this.state.defTableData)));
    let { value } = event.target;
    this.setState({ searchText: value }, () => {
      if (value.length > 0) {
        filterData = filterData.filter((row: any) => {
          return (
            row.explanation?.toString().toLowerCase().includes(value.toLowerCase()) ||
            row.collectedTax?.toLowerCase().includes(value.toLowerCase()) ||
            row.expectedTax?.toString().toLowerCase().includes(value.toLowerCase()) ||
            row.variance?.toString().toLowerCase().includes(value.toLowerCase())
          )
        });
      }
      this.setState({ tableData: filterData });
    });
  }

  toggleTaxCategoryModal = (row: any = {}) => {
    this.setState((props) => ({ taxCatModal: !props.taxCatModal }), () => {
      if (this.state.taxCatModal) {
        row.revenue = this.props?.tabData?.revenue;
        row.filterHotelId = this.props?.filterHotelId;
        row.selectedDate = this.props?.selectedDate;
        row.collectedTax = Utils.removecurrencyFormat(row?.collectedTax);
        row.expectedTax = Utils.removecurrencyFormat(row?.expectedTax);
        row.variance = Utils.removecurrencyFormat(row?.variance);
      }
      this.setState((props) => ({ selectedRow: props?.taxCatModal ? row : {}, taxCategoryModal: props?.taxCatModal }))
    })
  }

  render() {
    let { tableData, taxCategoryModal } = this.state;

    const notesIcon = () => {
      return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.25 0.25H1.75C0.925 0.25 0.25 0.925 0.25 1.75V12.25C0.25 13.075 0.925 13.75 1.75 13.75H12.25C13.075 13.75 13.75 13.075 13.75 12.25V1.75C13.75 0.925 13.075 0.25 12.25 0.25ZM7.75 10.75H4C3.5875 10.75 3.25 10.4125 3.25 10C3.25 9.5875 3.5875 9.25 4 9.25H7.75C8.1625 9.25 8.5 9.5875 8.5 10C8.5 10.4125 8.1625 10.75 7.75 10.75ZM10 7.75H4C3.5875 7.75 3.25 7.4125 3.25 7C3.25 6.5875 3.5875 6.25 4 6.25H10C10.4125 6.25 10.75 6.5875 10.75 7C10.75 7.4125 10.4125 7.75 10 7.75ZM10 4.75H4C3.5875 4.75 3.25 4.4125 3.25 4C3.25 3.5875 3.5875 3.25 4 3.25H10C10.4125 3.25 10.75 3.5875 10.75 4C10.75 4.4125 10.4125 4.75 10 4.75Z" fill="none" />
        </svg>
      )
    }

    const plusIcon = () => {
      return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 4.25C7.5875 4.25 7.25 4.5875 7.25 5V7.25H5C4.5875 7.25 4.25 7.5875 4.25 8C4.25 8.4125 4.5875 8.75 5 8.75H7.25V11C7.25 11.4125 7.5875 11.75 8 11.75C8.4125 11.75 8.75 11.4125 8.75 11V8.75H11C11.4125 8.75 11.75 8.4125 11.75 8C11.75 7.5875 11.4125 7.25 11 7.25H8.75V5C8.75 4.5875 8.4125 4.25 8 4.25ZM8 0.5C3.86 0.5 0.5 3.86 0.5 8C0.5 12.14 3.86 15.5 8 15.5C12.14 15.5 15.5 12.14 15.5 8C15.5 3.86 12.14 0.5 8 0.5ZM8 14C4.6925 14 2 11.3075 2 8C2 4.6925 4.6925 2 8 2C11.3075 2 14 4.6925 14 8C14 11.3075 11.3075 14 8 14Z" fill="none" />
        </svg>
      )
    }

    const borderFormatter = (column, colIndex) => {
      return (
        <>{column.text}<div className="border-bottom"></div></>
      );
    }

    const borderFooterFormatter = (column, colIndex, { text }) => {
      if (this.state.searchText.length > 0 && tableData.length === 0) {
        return "";
      }
      return (
        <>
          <div className="border-top"></div>
          <div className="border-bottom"></div>
        </>
      );
    }

    const columns = [{
      dataField: 'explanation',
      text: 'Type',
      headerFormatter: borderFormatter,
      formatter: (cell, row, rowIndex) => (<EllipsisWithTooltip placement="bottom">{row.explanation}</EllipsisWithTooltip>),
      footer: (columnData, column) => {
        return (this.state.searchText.length > 0 && tableData.length === 0) ? <></> : (
          <>
            <div><ul><li className="lable">Totals</li></ul></div>
            <div className="border-top"></div>
            <div className="border-bottom"></div>
          </>
        )
      },
    }, {
      dataField: "collectedTax",
      text: "Collected Tax",
      headerFormatter: borderFormatter,
      headerClasses: "align-right width-140",
      classes: "align-right",
      formatter: (cell, row, rowIndex) => (
        <EllipsisWithTooltip placement="bottom">{row.collectedTax}</EllipsisWithTooltip>
      ),
      footer: (columnData) => columnData.reduce((acc, item) => acc + item, 0),
      footerAlign: (column, colIndex) => "right",
      footerFormatter: (column, colIndex, { text }) => {
        return (this.state.searchText.length > 0 && tableData.length === 0) ? <></> : (
          <>
            <div className="value">
              <EllipsisWithTooltip placement="bottom">
                {Utils.currencyFormatWithOutdoller(tableData.reduce((acc, item: any) => acc + (+Utils.removeInvaildCharFromAmount(item?.collectedTax) || 0), 0))}
              </EllipsisWithTooltip>
            </div>
            <div className="border-top"></div>
            <div className="border-bottom"></div>
          </>
        )
      }
    },
    {
      dataField: 'expectedTax',
      text: 'Expected Tax',
      headerFormatter: borderFormatter,
      headerClasses: "align-right width-140",
      classes: "align-right",
      formatter: (cell, row, rowIndex) => (
        <EllipsisWithTooltip placement="bottom">{row.expectedTax}</EllipsisWithTooltip>
      ),
      footer: (columnData) => columnData.reduce((acc, item) => acc + item, 0),
      footerAlign: (column, colIndex) => "right",
      footerFormatter: (column, colIndex, { text }) => {
        return (this.state.searchText.length > 0 && tableData.length === 0) ? <></> : (
          <>
            <div className="value">
              <EllipsisWithTooltip placement="bottom">
                {Utils.currencyFormatWithOutdoller(tableData.reduce((acc, item: any) => acc + (+Utils.removeInvaildCharFromAmount(item?.expectedTax) || 0), 0))}
              </EllipsisWithTooltip>
            </div>
            <div className="border-top"></div>
            <div className="border-bottom"></div>
          </>
        )
      }
    },
    {
      dataField: 'variance',
      text: 'Variance',
      headerClasses: "align-right width-140",
      classes: "align-right",
      headerFormatter: borderFormatter,
      formatter: (cell, row, rowIndex) => (
        <EllipsisWithTooltip placement="bottom"><span style={{ color: "#d3412e" }}>{row?.variance}</span></EllipsisWithTooltip>
      ),
      footer: (columnData) => columnData.reduce((acc, item) => acc + item, 0),
      footerAlign: (column, colIndex) => "right",
      footerFormatter: (column, colIndex, { text }) => {
        return (this.state.searchText.length > 0 && tableData.length === 0) ? <></> : (
          <>
            <div className="value">
              <EllipsisWithTooltip placement="bottom">
                {Utils.currencyFormatWithOutdoller(tableData.reduce((acc, item: any) => acc + (+Utils.removeInvaildCharFromAmount(item?.variance) || 0), 0))}
              </EllipsisWithTooltip>
            </div>
            <div className="border-top"></div>
            <div className="border-bottom"></div>
          </>
        )
      }
    },
    {
      dataField: 'explanation',
      text: 'Explanation',
      headerFormatter: borderFormatter,
      footerFormatter: borderFooterFormatter,
      headerClasses: "align-right width-140",
      classes: "right-explanation align-right pr-4",
      formatter: (cell, row, rowIndex) => {
        if (row.explanation1 === null) {
          return (<Button onClick={() => this.toggleTaxCategoryModal(row)} className="btn-outline-primary border-0 more">{plusIcon()}</Button>)
        } else {
          return (<Button onClick={() => this.toggleTaxCategoryModal(row)} className="btn-outline-primary border-0 more">{notesIcon()}</Button>)
        }
      },
      footer: '',
    }];

    return (
      <div className='payment-section reuse-sub-design'>
        {taxCategoryModal && (
          <TaxCategoty
            {...this.state}
            close={this.toggleTaxCategoryModal}
          />
        )}

        <div className='filter-section d-flex'>
          <div className='search-input sec'>
            {this.state.isDataLoading ? (<div className="single-loader taxaudit-search-loader loadingAnimation"></div>) : (
              <Form.Control type="text" placeholder="Search" value={this.state.searchText} onChange={(e) => this.handleSearch(e)} />
            )}
          </div>
          <div className='ml-auto'><div className='togglebtn d-flex align-items-center'></div></div>
        </div>

        {this.state.isDataLoading ? (
          <div className="taxAuditloader"><ReactPageLoader useas={"revenue-nonrevenue"} /></div>
        ) : (
          <div className="body-section tbl-footer tabAuditTable">
            <BootstrapTable
              keyField="rankNumber"
              data={tableData}
              columns={columns}
              noDataIndication="No data found"
            />
          </div>
        )}

        {this.state.isModified && (
          <div className='footer-section d-flex align-items-center'>
            <div className='msg'>You have unsaved changes</div>
            <div className='ml-auto action'>
              <Button variant="primary" type="button" className="space btn btn-primary btn-discard">Discard</Button>
              <Button variant="primary" type="button" className="btn btn-primary">Save Changes</Button>
            </div>
          </div>
        )}

        {this.state.isDataSaving && (
          <div className="loader-spinner d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="success" />
          </div>
        )}
      </div>
    );
  }
}

export default TaxAudit;
